package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "en", default = true)
val EnStrings = Strings(
    analyzer = "Analyzer",
    appreciationOverview = "Appreciation Overview",
    chartLegendInterest = "Interest",
    chartLegendPrincipal = "Principal",
    chartXaxisMonths = "Months",
    chartYaxisPayment = "Payment",
    code = "en",
    costOfCredit = "Cost of Credit",
    creditDealAnalyzerDescription = "Enter your loan details to receive a comprehensive analysis of your credit deal. Our analyzer evaluates the key metrics to help you understand the true cost of your loan and make an informed decision.",
    detailsGoodRateLongTerm = "Good rate but long term results in high total cost.",
    detailsHighApr = "High APR. ",
    detailsHighInterestCost = "High total interest cost.",
    detailsHighRateShortTerm = "High rate but short term keeps total cost low.",
    detailsLowApr = "Low APR. ",
    detailsLowInterestCost = "Low total interest cost.",
    discountsTradeIn = "Discounts / Trade-in",
    displayName = "English",
    distribution = "Distribution",
    downPayment = "Down Payment",
    effectiveApr = "APR",
    headerBalance = "Balance",
    headerDate = "Date",
    headerInterest = "Interest",
    headerMonth = "#",
    headerPayment = "Payment",
    headerPrincipal = "Principal",
    hideDetails = "Hide Details",
    interest = "Interest",
    invalidData = "Invalid Data",
    loanAmountSupportingText = "The total loan amount, including any additional costs.",
    loanDetails = "Loan Details",
    paymentSupportingText = "Your estimated monthly payment.",
    paymentComposition = "Payment Composition",
    percentSymbol = "%",
    principal = "Principal",
    ratingBad = "Bad Deal",
    ratingExcellent = "Excellent Deal",
    ratingFair = "Fair Deal",
    ratingGood = "Good Deal",
    ratingPoor = "Poor Deal",
    schedule = "Schedule",
    showDetails = "Show Details",
    summaryBad = "Very unfavorable, avoid if possible.",
    summaryExcellent = "Excellent financial conditions.",
    summaryFair = "Fair conditions, consider negotiating.",
    summaryGood = "Good conditions, standard for the market.",
    summaryPoor = "Poor conditions, high cost or rate.",
    totalPaid = "Total Paid",
    lockTaxRate = "Lock TaxRate",
    unlockTaxRate = "Unlock TaxRate",
    currencySymbol = "$",
    currency = "Currency",

    totalCreditAmount = "Total Amount of Credit",

    taxAmount = "Tax/Deduction Amount",
    netAmountDisbursed = "Net Amount Disbursed",
    years = "Years",

    loanTermTotalMonths = "Loan Term (Months)",
    monthlyInstallment = "Monthly Installment",
    principalInstallment = "Principal Installment",
    otherFees = "Other Fees",
    insuranceCost = "Insurance Premium",

    aprc = "Annual Percentage Rate of Charge (APRC)",
    totalAmountPayable = "Total Amount Payable",
    prepaidFeeFixed = "Processing Fee (Fixed Amount)",
    prepaidFeePercentage = "Processing Fee (Percentage)",

    months = "Months",
    description = "This analyzer helps you evaluate whether a loan offer is favorable for you. Unlike standard calculators, it does not require an interest rate input. Instead, it calculates the APR and total cost of credit based on payments and fees, providing a deal rating and detailed charts.",
    agree = "Agree",
    information = "Information",
    errorCalculationOverflow = "APR is too high, calculation overflow.",

    errorTotalPaymentIsLessThanLoanAmount = "Received Amount payment is less than loan amount.",
    errorDivisionByZero = "Division by zero",
    errorNegativeResult = "Negative result",
    errorRateTooHigh = "Rate is too high",
    errorCalculation = "Please enter correct data",
    close = "Close",

    hi = "Hi",
    guest = "Guest",
    account = "Account",
    signInWithGoogle = "Sign in with Google",
    signOut = "Sign out",
    settings = "Settings",
    about = "About",
    privacyPolicy = "Privacy Policy",
    termsOfService = "Terms of Service",
    language = "Language",

    theme = "Theme",
    light = "Light",
    dark = "Dark",
    system = "System",
    toggleExpand = "Toggle Expand",
)
